





import Vue from 'vue';

export default Vue.extend({
  name: 'Title',
  props: {
    size: {
      validator(value: string): boolean {
        return ['large', 'medium', 'small'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    isSmall(): boolean {
      return this.size === 'small';
    },
  },
});
